import React from 'react';
import Inputs from '../../../shared/Inputs';

const Modals = ({
	modalState,
	setModalState,
	formData,
	handleFormChange,
	createList,
	currentId,
	editList,
	deleteList,
}) => {
	return (
		<>
			<div id="modal">
				<div
					className={
						modalState == 'new'
							? 'modal-window-modal active'
							: 'modal-window-modal'
					}
				>
					<div
						className={
							modalState == 'new'
								? 'modal-window active'
								: 'modal-window'
						}
					>
						<div>
							<div className="title-section">
								<h3>Create a new list</h3>
								<span>
									Create a list around a project, a topic or
									for inspiration.
								</span>
							</div>
							<form>
								<Inputs
									inputType="name"
									label="List name"
									placeholder='For example, "Sports & Community"'
									data={formData}
									onChange={handleFormChange}
								/>
								<div className="text-right">
									<div
										className="secondary-button"
										style={{ marginRight: '1rem' }}
										onClick={() => setModalState('')}
									>
										<p>Cancel</p>
									</div>
									<div
										className="primary-button"
										onClick={createList}
									>
										<p>Save</p>
									</div>
								</div>
							</form>
						</div>
					</div>
					<div
						className="modal-background"
						onClick={() => setModalState('')}
					></div>
				</div>
			</div>

			<div id="modal">
				<div
					className={
						modalState == 'edit'
							? 'modal-window-modal active'
							: 'modal-window-modal'
					}
				>
					<div
						className={
							modalState == 'edit'
								? 'modal-window active'
								: 'modal-window'
						}
					>
						<div>
							<div className="title-section">
								<h3>Edit list</h3>
							</div>
							<form>
								<Inputs
									inputType="name"
									label="List name"
									placeholder='For example, "Sports & Community"'
									data={formData}
									onChange={handleFormChange}
								/>
								<div className="text-right">
									<div
										className="secondary-button"
										style={{ marginRight: '1rem' }}
										onClick={() => setModalState('')}
									>
										<p>Cancel</p>
									</div>
									<div
										className="primary-button"
										onClick={() => editList(currentId)}
									>
										<p>Save</p>
									</div>
								</div>
							</form>
						</div>
					</div>
					<div
						className="modal-background"
						onClick={() => setModalState('')}
					></div>
				</div>
			</div>

			<div id="modal" className="delete-list-modal">
				<div
					className={
						modalState == 'delete'
							? 'modal-window-modal active'
							: 'modal-window-modal'
					}
				>
					<div
						className={
							modalState == 'delete'
								? 'modal-window active'
								: 'modal-window'
						}
					>
						<div>
							<div className="title-section">
								<h3>Delete list?</h3>
								<span>
									All the content you saved to this list will
									be permantly lost. Are you sure?
								</span>
							</div>
							<div className="text-right">
								<div
									className="secondary-button"
									style={{ marginRight: '1rem' }}
									onClick={() => setModalState('')}
								>
									<p>Cancel</p>
								</div>
								<div
									className="primary-button"
									onClick={() => deleteList(currentId)}
								>
									<p>Delete list</p>
								</div>
							</div>
						</div>
					</div>
					<div
						className="modal-background"
						onClick={() => setModalState('')}
					></div>
				</div>
			</div>
		</>
	);
};

export default Modals;
